import Offcanvas from 'bootstrap/js/src/offcanvas'

export const selector = [
    '.offcanvas',
    '.offcanvas-sm',
    '.offcanvas-md',
    '.offcanvas-lg',
    '.offcanvas-xl',
    '.offcanvas-xxl'
].join(',')

export default (
    el = null
) => {
    if (!el)
        return

    console.groupCollapsed('Offcanvas')

    const instance = Offcanvas.getInstance(el)

    if (instance)
        instance.dispose()

    const offcanvas = new Offcanvas(el)

    console.log(el, offcanvas)

    console.groupEnd()

    return el
}
